import { routeAccess } from 'app/access';
import RequireAuth from 'app/components/RequireAuth';
import { lazy } from 'react';
import { Route } from 'react-router';

const ReportTemplatesRoute = lazy(() => import('./report-templates/ReportTemplatesRoute'));
const ReportTemplateRoute = lazy(() => import('./report-templates/ReportTemplateRoute'));
const ReportSearchRoute = lazy(() => import('app/routes/reports/ReportSearchRoute'));
const ReportProductionRoute = lazy(() => import('./reports-production/ReportProductionRoute'));
const FailedReportsRoute = lazy(() => import('./failed-reports/FailedReportsRoute'));
const UpdateReportTemplateRoute = lazy(() => import('./report-templates/UpdateReportTemplateRoute'));
const ReportStatisticsRoute = lazy(() => import('./reports-statistics/ReportStatisticsRoute'));

export default [
  <Route
    key="report-search"
    path="/report-search"
    element={
      <RequireAuth {...routeAccess.reportSearch}>
        <ReportSearchRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="report-templates"
    path="/report-templates"
    element={
      <RequireAuth {...routeAccess.reportTemplates}>
        <ReportTemplatesRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="report-template"
    path="/report-templates/:id"
    element={
      <RequireAuth {...routeAccess.reportTemplates}>
        <ReportTemplateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="update-template"
    path="/report-templates/:id/update-template"
    element={
      <RequireAuth {...routeAccess.reportTemplateUpdate}>
        <UpdateReportTemplateRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="report-production"
    path="/report-production"
    element={
      <RequireAuth {...routeAccess.reportProduction}>
        <ReportProductionRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="report-statistics"
    path="/report-statistics"
    element={
      <RequireAuth {...routeAccess.reportStatistics}>
        <ReportStatisticsRoute />
      </RequireAuth>
    }
  />,
  <Route
    key="failed-reports"
    path="/failed-reports"
    element={
      <RequireAuth {...routeAccess.failedReports}>
        <FailedReportsRoute />
      </RequireAuth>
    }
  />,
];
